import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("gensan_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const fileUrl = (path) => {
  if (!path) return null;
  if (path.startsWith("http")) return path;
  return `${API}/files/${path}`;
};

export const formatPrice = (price) => {
  return new Intl.NumberFormat("tr-TR", {
    style: "currency",
    currency: "TRY",
    maximumFractionDigits: 0,
  }).format(price);
};

export const WHATSAPP_NUMBER = "905555555555"; // placeholder
export const PHONE_NUMBER = "0216 388 10 01";
export const PHONE_TEL = "+902163881001";
export const SALES_PHONE = "0537 412 12 24";
export const SALES_TEL = "+905374121224";
export const SERVICE_PHONE = "0554 583 12 63";
export const SERVICE_TEL = "+905545831263";
export const EMAIL = "info@gensan.com.tr";
export const ADDRESS = "Girne Mah. Irmaklar Sk. Küçükyalı İş Merkezi No: 17 B Blok";
export const INSTAGRAM = "gensan_motors";
